import styled from 'styled-components'

export const SearchContainer = styled.div`
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    ul {
      max-height: 80px;
    }
  }
`
